"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("@/assets/styles/index.scss");
var _vue = _interopRequireDefault(require("vue"));
var _App = _interopRequireDefault(require("./App"));
var _i18n = _interopRequireDefault(require("./i18n"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _moment = _interopRequireDefault(require("moment"));
var _pluginsKit = _interopRequireDefault(require("./plugins/plugins-kit"));
require("./permission");
require("./utils/error-log");
var filters = _interopRequireWildcard(require("./filters"));
var _elementUi = _interopRequireDefault(require("element-ui"));
require("element-ui/lib/theme-chalk/index.css");
var _vueEllipseProgress = _interopRequireDefault(require("vue-ellipse-progress"));
var _raygun4js = _interopRequireDefault(require("raygun4js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*!
 =========================================================
 * HivePlace BackOffice - v1.0.0
 =========================================================
 * Product Page: https://backoffice.hiveplace.com.br
 * Copyright 2020 Skill
 * Designed by www.skilltecnologia.com Coded by skilltecnologia.com.br
 =========================================================
 */
/* Styles */

// Libs

// permission control

// global filters

// Raygun

// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});

// ProductionTip
_vue.default.config.productionTip = false;

// Config raygun
(0, _raygun4js.default)('apiKey', process.env.VUE_KEY_ACCESS_RAYGUN);
(0, _raygun4js.default)('enableCrashReporting', true);
(0, _raygun4js.default)('enableRealUserMonitoring', true);
_vue.default.config.errorHandler = function (err, vm, info) {
  (0, _raygun4js.default)('send', {
    error: err,
    customData: [{
      info: info
    }]
  });
};

// Plugins
_vue.default.use(_pluginsKit.default);
_vue.default.use(_elementUi.default);
_vue.default.use(_vueEllipseProgress.default);

// translate date format
_moment.default.locale('pt-BR');
new _vue.default({
  el: '#app',
  i18n: _i18n.default,
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
});